import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=c18819ec&scoped=true"
import script from "./ProposalsList.vue?vue&type=script&lang=js"
export * from "./ProposalsList.vue?vue&type=script&lang=js"
import style0 from "./ProposalsList.vue?vue&type=style&index=0&id=c18819ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18819ec",
  null
  
)

export default component.exports